export interface ProductReview {
  id: string;
  userId: string;
  userName: string;
  userAvatar: string;
  rating: number;
  comment: string;
  date: string;
}

export interface ProductSpecification {
  name: string;
  value: string;
}

export interface ProductSeller {
  id: string;
  name: string;
  logo: string;
  location: string;
  rating: number;
  verified: boolean;
  joinedDate: string;
}

export interface ProductBrand {
  id: string;
  name: string;
  logo_url?: string;
  verified?: boolean;
}

export interface Product {
  id: string;
  slug?: string;
  name: string;
  categoryId: string;
  subCategoryId: string;
  productCategoryId: string;
  condition: "New" | "Used" | "Refurbished";
  price: number;
  previousPrice?: number;
  currency: string;
  description: string;
  features: string[];
  specifications: ProductSpecification[];
  images: string[];
  year?: number;
  manufacturer: string;
  model: string;
  hoursUsed?: number;
  location: string;
  seller: ProductSeller;
  brand?: ProductBrand;
  rating: number;
  reviewCount: number;
  reviews: ProductReview[];
  listedDate: string;
  financing: boolean;
  warranty?: string;
  inStock: boolean;
  deliveryAvailable: boolean;
  deliveryFee?: number;
  featured: boolean;
  supplierRating?: number;
  supplierReviewCount?: number;
  supplierResponseRate?: number;
  supplierPhoneNumber?: string;
  supplierVerified?: boolean;
  supplierCertified?: boolean;
  isLeadingSupplier?: boolean;
}

export const MACHINERY_PRODUCTS: Product[] = [
  // Excavators
  {
    id: "exc-001",
    name: "CAT 320 GC Hydraulic Excavator",
    categoryId: "construction-and-heavy-equipment",
    subCategoryId: "earthmoving",
    productCategoryId: "excavators",
    condition: "New",
    price: 215000,
    currency: "INR",
    description:
      "The Cat 320 GC excavator balances productivity with easy-to-use controls, a new comfortable cab, reduced fuel consumption by up to 20%, and reduced maintenance costs by up to 20% to give you a durable, low-cost-per-hour excavator for your applications.",
    features: [
      "Cat C4.4 engine",
      "Operating weight: 21.9 tons",
      "Maximum digging depth: 6.72m",
      "Maximum reach at ground level: 9.87m",
      "Integrated Cat Connect technology",
    ],

    specifications: [
      { name: "Engine Power", value: "121 kW" },
      { name: "Operating Weight", value: "21900 kg" },
      { name: "Maximum Digging Depth", value: "6.72 m" },
      { name: "Bucket Capacity", value: "1.19 m³" },
      { name: "Fuel Tank Capacity", value: "345 L" },
    ],

    images: [
      "https://picsum.photos/seed/cat320gc1/800/600",
      "https://picsum.photos/seed/cat320gc2/800/600",
      "https://picsum.photos/seed/cat320gc3/800/600",
      "https://picsum.photos/seed/cat320gc4/800/600",
    ],

    manufacturer: "Caterpillar",
    model: "320 GC",
    location: "Dallas, TX",
    brand: {
      id: "brand-001",
      name: "Caterpillar",
      logo_url: "https://picsum.photos/seed/caterpillar/200/200",
      verified: true
    },
    seller: {
      id: "sel-001",
      name: "Heavy Equipment Solutions",
      logo: "https://picsum.photos/seed/heavyequip/200/200",
      location: "Dallas, TX",
      rating: 4.8,
      verified: true,
      joinedDate: "2018-03-15",
    },
    rating: 4.7,
    reviewCount: 23,
    reviews: [
      {
        id: "rev-001",
        userId: "user-001",
        userName: "John Smith",
        userAvatar: "https://github.com/yusufhilmi.png",
        rating: 5,
        comment:
          "Excellent machine, very fuel efficient and the controls are intuitive.",
        date: "2023-05-12",
      },
      {
        id: "rev-002",
        userId: "user-002",
        userName: "Mike Johnson",
        userAvatar: "https://github.com/furkanksl.png",
        rating: 4,
        comment: "Great excavator, but the cab could be a bit more spacious.",
        date: "2023-04-03",
      },
    ],

    listedDate: "2023-03-01",
    financing: true,
    warranty: "3 years or 5000 hours",
    inStock: true,
    deliveryAvailable: true,
    deliveryFee: 2500,
    featured: true,
  },
  {
    id: "exc-002",
    name: "Komatsu PC210LC-11 Hydraulic Excavator",
    categoryId: "construction-and-heavy-equipment",
    subCategoryId: "earthmoving",
    productCategoryId: "excavators",
    condition: "Used",
    price: 145000,
    previousPrice: 160000,
    currency: "INR",
    description:
      "This well-maintained Komatsu PC210LC-11 excavator offers exceptional performance and reliability. With only 3,500 hours, it's in excellent condition and ready to work on your next project.",
    features: [
      "Komatsu SAA6D107E-3 engine",
      "Operating weight: 22.4 tons",
      "Maximum digging depth: 6.62m",
      "Komtrax monitoring system",
      "Enhanced working environment",
    ],

    specifications: [
      { name: "Engine Power", value: "123 kW" },
      { name: "Operating Weight", value: "22400 kg" },
      { name: "Maximum Digging Depth", value: "6.62 m" },
      { name: "Bucket Capacity", value: "1.20 m³" },
      { name: "Fuel Tank Capacity", value: "400 L" },
    ],

    images: [
      "https://picsum.photos/seed/komatsupc210-1/800/600",
      "https://picsum.photos/seed/komatsupc210-2/800/600",
      "https://picsum.photos/seed/komatsupc210-3/800/600",
    ],

    year: 2020,
    manufacturer: "Komatsu",
    model: "PC210LC-11",
    hoursUsed: 3500,
    location: "Houston, TX",
    brand: {
      id: "brand-002",
      name: "Komatsu",
      logo_url: "https://picsum.photos/seed/komatsu/200/200",
      verified: false
    },
    seller: {
      id: "sel-002",
      name: "Southern Construction Equipment",
      logo: "https://picsum.photos/seed/southernconstruct/200/200",
      location: "Atlanta, GA",
      rating: 4.6,
      verified: true,
      joinedDate: "2017-09-22",
    },
    rating: 4.5,
    reviewCount: 18,
    reviews: [
      {
        id: "rev-003",
        userId: "user-003",
        userName: "David Wilson",
        userAvatar: "https://github.com/kdrnp.png",
        rating: 5,
        comment:
          "Excellent used machine, runs like new. Very satisfied with the purchase.",
        date: "2023-02-18",
      },
    ],

    listedDate: "2023-01-15",
    financing: true,
    warranty: "6 months",
    inStock: true,
    deliveryAvailable: true,
    deliveryFee: 2000,
    featured: false,
  },

  // Farm Tractors
  {
    id: "trac-001",
    name: "John Deere 8R 410 Tractor",
    categoryId: "agricultural",
    subCategoryId: "tractors-equipment",
    productCategoryId: "farm-tractors",
    condition: "New",
    price: 389000,
    currency: "INR",
    description:
      "The John Deere 8R 410 tractor delivers unprecedented power and intelligence with the latest precision ag technology. Experience superior comfort, visibility, and control with the redesigned cab and CommandPRO joystick.",
    features: [
      "John Deere PowerTech 9.0L engine",
      "e23 PowerShift transmission",
      "CommandView III cab",
      "CommandCenter 4600 display",
      "JDLink connectivity",
    ],

    specifications: [
      { name: "Engine Power", value: "410 hp" },
      { name: "PTO Power", value: "356 hp" },
      { name: "Hydraulic Flow", value: "85 GPM" },
      { name: "Fuel Capacity", value: "695 L" },
      { name: "Wheelbase", value: "3.05 m" },
    ],

    images: [
      "https://picsum.photos/seed/johndeere8r-1/800/600",
      "https://picsum.photos/seed/johndeere8r-2/800/600",
      "https://picsum.photos/seed/johndeere8r-3/800/600",
      "https://picsum.photos/seed/johndeere8r-4/800/600",
    ],

    manufacturer: "John Deere",
    model: "8R 410",
    location: "Des Moines, IA",
    seller: {
      id: "sel-003",
      name: "Midwest Farm Equipment",
      logo: "https://picsum.photos/seed/midwestfarm/200/200",
      location: "Des Moines, IA",
      rating: 4.9,
      verified: true,
      joinedDate: "2015-06-10",
    },
    rating: 4.8,
    reviewCount: 32,
    reviews: [
      {
        id: "rev-004",
        userId: "user-004",
        userName: "Robert Miller",
        userAvatar: "https://github.com/yahyabedirhan.png",
        rating: 5,
        comment:
          "Best tractor I've ever owned. The technology makes farming so much more efficient.",
        date: "2023-06-20",
      },
      {
        id: "rev-005",
        userId: "user-005",
        userName: "Thomas Brown",
        userAvatar: "https://github.com/buyuktas18.png",
        rating: 5,
        comment:
          "Incredible power and the cab comfort is outstanding. Worth every penny.",
        date: "2023-05-15",
      },
    ],

    listedDate: "2023-04-01",
    financing: true,
    warranty: "5 years or 3000 hours",
    inStock: true,
    deliveryAvailable: true,
    deliveryFee: 3500,
    featured: true,
  },

  // CNC Machines
  {
    id: "cnc-001",
    name: "Haas VF-2SS Super-Speed Vertical Machining Center",
    categoryId: "industrial",
    subCategoryId: "manufacturing",
    productCategoryId: "cnc-machines",
    condition: "New",
    price: 84995,
    currency: "INR",
    description:
      "The Haas VF-2SS Super-Speed VMC provides the high-performance capabilities of our SS Series machines in a small-footprint design. With 12,000-rpm spindle, high-speed rapids, and lightning-fast tool changes, the VF-2SS is perfect for high-volume production and reduced cycle times.",
    features: [
      "12,000-rpm inline direct-drive spindle",
      "24+1 side-mount tool changer",
      "High-speed rapids on all axes",
      "1,200 ipm cutting feedrates",
      'Haas control with 15" color LCD',
    ],

    specifications: [
      { name: "X-Axis Travel", value: "762 mm" },
      { name: "Y-Axis Travel", value: "406 mm" },
      { name: "Z-Axis Travel", value: "508 mm" },
      { name: "Table Size", value: "914 x 356 mm" },
      { name: "Max Weight on Table", value: "680 kg" },
    ],

    images: [
      "https://picsum.photos/seed/haasvf2ss-1/800/600",
      "https://picsum.photos/seed/haasvf2ss-2/800/600",
      "https://picsum.photos/seed/haasvf2ss-3/800/600",
    ],

    manufacturer: "Haas",
    model: "VF-2SS",
    location: "Chicago, IL",
    brand: {
      id: "brand-003",
      name: "Haas",
      logo_url: "https://picsum.photos/seed/haas/200/200",
      verified: true
    },
    seller: {
      id: "sel-004",
      name: "Precision Machinery Sales",
      logo: "https://picsum.photos/seed/precisionmach/200/200",
      location: "Chicago, IL",
      rating: 4.7,
      verified: true,
      joinedDate: "2016-11-08",
    },
    rating: 4.9,
    reviewCount: 15,
    reviews: [
      {
        id: "rev-006",
        userId: "user-006",
        userName: "James Anderson",
        userAvatar: "https://github.com/yusufhilmi.png",
        rating: 5,
        comment:
          "Incredible precision and reliability. The control interface is intuitive and easy to use.",
        date: "2023-07-05",
      },
    ],

    listedDate: "2023-06-10",
    financing: true,
    warranty: "2 years parts and labor",
    inStock: true,
    deliveryAvailable: true,
    deliveryFee: 1800,
    featured: true,
  },

  // Dump Trucks
  {
    id: "dump-001",
    name: "Volvo A45G Articulated Dump Truck",
    categoryId: "transportation",
    subCategoryId: "trucks",
    productCategoryId: "dump-trucks",
    condition: "Used",
    price: 320000,
    previousPrice: 350000,
    currency: "INR",
    description:
      "This 2019 Volvo A45G articulated dump truck is in excellent condition with only 2,800 hours. It offers outstanding performance with its powerful engine, high payload capacity, and advanced features for improved productivity and fuel efficiency.",
    features: [
      "Volvo D16 engine",
      "45-ton payload capacity",
      "Automatic Traction Control (ATC)",
      "On-Board Weighing system",
      "Hill Assist and Dump Brake",
    ],

    specifications: [
      { name: "Engine Power", value: "350 kW" },
      { name: "Payload Capacity", value: "45 tonnes" },
      { name: "Body Volume", value: "25.1 m³" },
      { name: "Max Speed", value: "57 km/h" },
      { name: "Fuel Tank Capacity", value: "480 L" },
    ],

    images: [
      "https://picsum.photos/seed/volvoa45g-1/800/600",
      "https://picsum.photos/seed/volvoa45g-2/800/600",
      "https://picsum.photos/seed/volvoa45g-3/800/600",
    ],

    year: 2019,
    manufacturer: "Volvo",
    model: "A45G",
    hoursUsed: 2800,
    location: "Denver, CO",
    brand: {
      id: "brand-004",
      name: "Volvo",
      logo_url: "https://picsum.photos/seed/volvo/200/200",
      verified: true
    },
    seller: {
      id: "sel-005",
      name: "Mountain State Equipment",
      logo: "https://picsum.photos/seed/mountainstate/200/200",
      location: "Denver, CO",
      rating: 4.5,
      verified: true,
      joinedDate: "2017-03-25",
    },
    rating: 4.6,
    reviewCount: 12,
    reviews: [
      {
        id: "rev-007",
        userId: "user-007",
        userName: "Richard Taylor",
        userAvatar: "https://github.com/furkanksl.png",
        rating: 5,
        comment:
          "Excellent dump truck, very reliable and powerful. Fuel efficiency is better than expected.",
        date: "2023-04-18",
      },
      {
        id: "rev-008",
        userId: "user-008",
        userName: "William Davis",
        userAvatar: "https://github.com/kdrnp.png",
        rating: 4,
        comment:
          "Great machine overall, but the cabin could use better sound insulation.",
        date: "2023-03-22",
      },
    ],

    listedDate: "2023-02-15",
    financing: true,
    warranty: "1 year or 1000 hours",
    inStock: true,
    deliveryAvailable: true,
    deliveryFee: 4000,
    featured: false,
  },

  // Portable Concrete Mixers
  {
    id: "pcm-001",
    name: "Honda 3.5 Cu. Ft. Portable Concrete Mixer",
    categoryId: "construction-and-heavy-equipment",
    subCategoryId: "drum-mixers",
    productCategoryId: "portable-concrete-mixer",
    condition: "New",
    price: 45000,
    currency: "INR",
    description:
      "The Honda 3.5 Cu. Ft. portable concrete mixer is perfect for small to medium concrete jobs. Features a powerful Honda GX160 engine and a rugged steel drum for reliable mixing performance on any job site.",
    features: [
      "Honda GX160 5.5 HP engine",
      "3.5 cu. ft. mixing capacity",
      "Steel paddles for thorough mixing",
      "Pneumatic wheels for easy transport",
      "Heavy-duty steel drum construction",
    ],

    specifications: [
      { name: "Engine Power", value: "5.5 HP" },
      { name: "Mixing Capacity", value: "3.5 cu. ft." },
      { name: "Drum Material", value: "Steel" },
      { name: "Weight", value: "195 lbs" },
      { name: "Wheel Type", value: "Pneumatic" },
    ],

    images: [
      "https://picsum.photos/seed/hondaconcretemixer1/800/600",
      "https://picsum.photos/seed/hondaconcretemixer2/800/600",
      "https://picsum.photos/seed/hondaconcretemixer3/800/600",
    ],

    manufacturer: "Honda",
    model: "CM-3.5",
    location: "Mumbai, Maharashtra",
    brand: {
      id: "brand-005",
      name: "Honda",
      logo_url: "https://picsum.photos/seed/honda/200/200",
      verified: true
    },
    seller: {
      id: "sel-006",
      name: "Construction Equipment India",
      logo: "https://picsum.photos/seed/constructequipindia/200/200",
      location: "Mumbai, Maharashtra",
      rating: 4.6,
      verified: true,
      joinedDate: "2019-08-12",
    },
    rating: 4.8,
    reviewCount: 25,
    reviews: [
      {
        id: "rev-009",
        userId: "user-009",
        userName: "Rajesh Kumar",
        userAvatar: "https://github.com/rajeshkumar.png",
        rating: 5,
        comment:
          "Excellent concrete mixer! Very reliable Honda engine and perfect size for our projects.",
        date: "2023-08-15",
      },
      {
        id: "rev-010",
        userId: "user-010",
        userName: "Suresh Patel",
        userAvatar: "https://github.com/sureshpatel.png",
        rating: 4,
        comment:
          "Good quality mixer, easy to transport and operate. Highly recommended.",
        date: "2023-07-22",
      },
    ],

    listedDate: "2023-06-01",
    financing: true,
    warranty: "2 years",
    inStock: true,
    deliveryAvailable: true,
    deliveryFee: 500,
    featured: true,
  },

  {
    id: "pcm-002", 
    name: "Bajaj 5/3.5 Portable Concrete Mixer",
    categoryId: "construction-and-heavy-equipment",
    subCategoryId: "drum-mixers",
    productCategoryId: "portable-concrete-mixer",
    condition: "New",
    price: 35000,
    currency: "INR",
    description:
      "The Bajaj 5/3.5 portable concrete mixer is designed for Indian construction needs. Features a reliable Bajaj engine and heavy-duty construction for long-lasting performance in tough conditions.",
    features: [
      "Bajaj M2M 5 HP engine",
      "3.5 cu. ft. drum capacity",
      "Cast iron gears",
      "Manual tilting mechanism",
      "Robust steel frame",
    ],

    specifications: [
      { name: "Engine Power", value: "5 HP" },
      { name: "Mixing Capacity", value: "3.5 cu. ft." },
      { name: "Gear Type", value: "Cast Iron" },
      { name: "Weight", value: "180 kg" },
      { name: "Tilting", value: "Manual" },
    ],

    images: [
      "https://picsum.photos/seed/bajajconcretemixer1/800/600",
      "https://picsum.photos/seed/bajajconcretemixer2/800/600",
      "https://picsum.photos/seed/bajajconcretemixer3/800/600",
    ],

    manufacturer: "Bajaj",
    model: "5/3.5",
    location: "Pune, Maharashtra",
    brand: {
      id: "brand-006",
      name: "Bajaj",
      logo_url: "https://picsum.photos/seed/bajaj/200/200",
      verified: true
    },
    seller: {
      id: "sel-007",
      name: "Bajaj Construction Equipment",
      logo: "https://picsum.photos/seed/bajajconstruction/200/200",
      location: "Pune, Maharashtra",
      rating: 4.5,
      verified: true,
      joinedDate: "2018-05-20",
    },
    rating: 4.6,
    reviewCount: 18,
    reviews: [
      {
        id: "rev-011",
        userId: "user-011",
        userName: "Amit Singh",
        userAvatar: "https://github.com/amitsingh.png",
        rating: 5,
        comment:
          "Great value for money. Perfect for small construction projects.",
        date: "2023-09-10",
      },
    ],

    listedDate: "2023-07-15",
    financing: false,
    warranty: "1 year",
    inStock: true,
    deliveryAvailable: true,
    deliveryFee: 300,
    featured: false,
  },

  {
    id: "pcm-003",
    name: "Crown 7/5 Heavy Duty Concrete Mixer",
    categoryId: "construction-and-heavy-equipment",
    subCategoryId: "drum-mixers",
    productCategoryId: "portable-concrete-mixer",
    condition: "New",
    price: 65000,
    currency: "INR",
    description:
      "The Crown 7/5 heavy duty concrete mixer is built for professional contractors. With its powerful 7 HP engine and 5 cu. ft. capacity, it handles larger mixing jobs with ease while maintaining portability.",
    features: [
      "7 HP Kohler engine",
      "5 cu. ft. mixing capacity",
      "Heavy duty steel construction",
      "Pneumatic tires",
      "Easy-pour design",
    ],

    specifications: [
      { name: "Engine Power", value: "7 HP" },
      { name: "Mixing Capacity", value: "5 cu. ft." },
      { name: "Engine Brand", value: "Kohler" },
      { name: "Weight", value: "230 kg" },
      { name: "Tire Type", value: "Pneumatic" },
    ],

    images: [
      "https://picsum.photos/seed/crownconcretemixer1/800/600",
      "https://picsum.photos/seed/crownconcretemixer2/800/600",
      "https://picsum.photos/seed/crownconcretemixer3/800/600",
    ],

    year: 2023,
    manufacturer: "Crown",
    model: "7/5 HD",
    location: "Delhi, NCR",
    brand: {
      id: "brand-007",
      name: "Crown",
      logo_url: "https://picsum.photos/seed/crown/200/200",
      verified: false
    },
    seller: {
      id: "sel-008",
      name: "Delhi Construction Machinery",
      logo: "https://picsum.photos/seed/delhiconstruction/200/200",
      location: "Delhi, NCR",
      rating: 4.7,
      verified: true,
      joinedDate: "2017-12-05",
    },
    rating: 4.7,
    reviewCount: 12,
    reviews: [
      {
        id: "rev-012",
        userId: "user-012",
        userName: "Vikram Sharma",
        userAvatar: "https://github.com/vikramsharma.png",
        rating: 5,
        comment:
          "Excellent mixer for heavy duty work. The Kohler engine is very reliable.",
        date: "2023-08-28",
      },
    ],

    listedDate: "2023-05-20",
    financing: true,
    warranty: "2 years parts and labor",
    inStock: true,
    deliveryAvailable: true,
    deliveryFee: 800,
    featured: true,
  },

  {
    id: "pcm-004",
    name: "Mini Electric Concrete Mixer 120L",
    categoryId: "construction-and-heavy-equipment",
    subCategoryId: "drum-mixers",
    productCategoryId: "portable-concrete-mixer",
    condition: "New",
    price: 25000,
    currency: "INR",
    description:
      "Compact 120L electric concrete mixer perfect for small residential projects. Quiet electric operation makes it ideal for urban construction sites with noise restrictions.",
    features: [
      "1.5 HP electric motor",
      "120L mixing capacity",
      "Quiet electric operation",
      "Compact design",
      "Easy tilt mechanism",
    ],

    specifications: [
      { name: "Motor Power", value: "1.5 HP" },
      { name: "Capacity", value: "120 Liters" },
      { name: "Power Type", value: "Electric" },
      { name: "Voltage", value: "220V" },
      { name: "Weight", value: "85 kg" },
    ],

    images: [
      "https://picsum.photos/seed/electricmixer120l1/800/600",
      "https://picsum.photos/seed/electricmixer120l2/800/600",
    ],

    manufacturer: "IndoMix",
    model: "EM-120",
    location: "Bangalore, Karnataka",
    brand: {
      id: "brand-008",
      name: "IndoMix",
      logo_url: "https://picsum.photos/seed/indomix/200/200",
      verified: false
    },
    seller: {
      id: "sel-009",
      name: "South India Equipment",
      logo: "https://picsum.photos/seed/southindiaequip/200/200",
      location: "Bangalore, Karnataka",
      rating: 4.3,
      verified: true,
      joinedDate: "2020-03-18",
    },
    rating: 4.4,
    reviewCount: 8,
    reviews: [
      {
        id: "rev-013",
        userId: "user-013",
        userName: "Arjun Reddy",
        userAvatar: "https://github.com/arjunreddy.png",
        rating: 4,
        comment:
          "Good for small jobs and very quiet operation. Perfect for residential work.",
        date: "2023-09-05",
      },
    ],

    listedDate: "2023-08-01",
    financing: false,
    warranty: "1 year",
    inStock: true,
    deliveryAvailable: true,
    deliveryFee: 200,
    featured: false,
  },
];
